<template>
  <div data-testid="summary-includes">
    <div class="text-[11px] uppercase text-white/55 mb-3">{{ translate('ai_summary_will_include', 'Your summary will include') }}</div>
    <div v-for="section in sections" :key="section.key" class="flex gap-3 mb-3">
      <span class="w-7 h-7 rounded-[6px] bg-[#1e2428] flex items-center justify-center text-primary shrink-0">
        <lib-icon :name="section.icon" size="16" />
      </span>
      <div class="text-[13px]">
        <div class="font-semibold text-white">{{ section.title }}</div>
        <div class="text-white/75 mt-0.5">{{ section.description }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import LibIcon from '@/components/ui/LibIcon.vue';
import { translate } from '@/composables/useCaptionSettings';

defineProps({
  sections: { type: Array, required: true },
});
</script>
